import logoUrl from '@assets/images/shri-ji-logo.svg';
import { MenuOutlined } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { useState } from 'react';


import { PAGE_MAX_WIDTH, PAGE_PX, TOPBAR_HEIGHT } from './layoutMetrics';
import { MobileNavDrawer } from './topbar/MobileNavDrawer';
import { NotificationBell } from './topbar/NotificationBell';
import { ProfileMenu } from './topbar/ProfileMenu';
import { ScopeSwitcher } from './topbar/ScopeSwitcher';
import { TopbarNav } from './topbar/TopbarNav';

export const Topbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Box
      sx={(theme) => ({
        height: TOPBAR_HEIGHT,
        py: '2px',
        bgcolor: 'white',
        borderBottom: `1px solid ${theme.palette.grey[50]}`,
        boxShadow: '0px 1px 1.5px rgba(0,0,0,0.06)',
        flexShrink: 0,
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
      })}
    >
     <Box
       sx={{
         display: 'flex',
         alignItems: 'center',
         gap: '8px',
         height: '100%',
         width: '100%',
         maxWidth: PAGE_MAX_WIDTH,
         mx: 'auto',
         px: PAGE_PX,
       }}
     >
      {/* Hamburger — below lg (the full nav + scope chips + controls only fit at lg+) */}
      <IconButton
        onClick={() => setDrawerOpen(true)}
        aria-label="Open navigation menu"
        sx={(theme) => ({ display: { xs: 'inline-flex', lg: 'none' }, flexShrink: 0, color: theme.palette.grey[700] })}
      >
        <MenuOutlined />
      </IconButton>

      {/* Logo */}
      <Box
        component="img"
        src={logoUrl}
        alt="Shri Ji Logo"
        sx={{ width: { xs: 44, lg: 60 }, height: { xs: 60, lg: 100 }, flexShrink: 0, objectFit: 'contain', padding: { xs: 0, lg: '4px' } }}
      />

      {/* Desktop nav — lg+ only */}
      <Box sx={{ display: { xs: 'none', lg: 'flex' }, flex: 1, minWidth: 0, height: '100%', alignItems: 'center' }}>
        <TopbarNav />
      </Box>

      {/* Spacer keeps right controls pinned right on small screens (no desktop nav to fill) */}
      <Box sx={{ display: { xs: 'block', lg: 'none' }, flex: 1 }} />

      {/* Right controls */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0, height: '100%' }}>
        <NotificationBell />
        {/* Scope chips — lg+ only; folded into the drawer on smaller screens */}
        <Box sx={{ display: { xs: 'none', lg: 'flex' }, alignItems: 'center', gap: '10px' }}>
          <ScopeSwitcher />
        </Box>
        <ProfileMenu />
      </Box>
     </Box>

     <MobileNavDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </Box>
  );
};
